export const components = {
  404: {
    whoops: '이런!',
    description: '페이지가 존재하지 않거나 액세스할 수 없는 것 같습니다. 자세한 내용은 앱 소유자에게 문의하세요.',
    ok: '확인'
  },
  emptyState: {
    primaryTitle: '이런!',
    primaryText: '아직 내용이 없어요...',
    secondaryTitle: '표시할 항목이 없음',
    secondaryText: '적용된 필터를 기반으로 표시할 항목이 없습니다...'
  },
  filters: {
    all: '모두',
    search: '검색',
    priceRange: '가격 범위 {currency}',
    minValue: '최소 값은 {val}입니다!',
    maxValue: '최대 값은 {val}입니다!',
    reset: '초기화',
    apply: '적용'
  },
  comments: {
    reply: '답글',
    loadMore: '더 보기',
    edited: '편집됨',
    noComments: '아직 댓글이 없습니다',
    leaveFirstComment: '첫 번째 댓글을 남겨보세요'
  },
  curtain: {
    close: '닫기'
  },
  photoPreview: {
    close: '닫기'
  },
  photoCropper: {
    back: '뒤로',
    save: '저장'
  },
  rightSidebar: {
    in: '에서'
  },
  pushPrompt: {
    title: '“{appName}”에서 알림을 보내고 싶어합니다',
    description: '알림에는 알림, 소리 및 아이콘 배지가 포함될 수 있습니다. 이를 설정에서 구성할 수 있습니다.',
    later: '나중에 물어봐주세요',
    neverLater: '다시 묻지 않음',
    allow: '허용'
  },
  inAppPush: {
    attachment: '첨부 파일'
  },
  installPrompt: {
    android: {
      install: '설치',
      description: '원활한 경험을 위해 브라우저를 사용할 필요가 없습니다. 앱으로 설치하세요.',
      press: '누르세요',
      andSelect: '및 선택하세요',
      orSimply: '또는 간단히',
      description2: '아래의 설치 버튼을 클릭하세요',
      notNow: '지금은 안 함'
    },
    ios: {
      justTap: '그냥 탭',
      buttonInBrowser: '브라우저의 버튼',
      addToHomeScreen: '“홈 화면에 추가”를 선택하세요',
      appWillBeInstalled: '앱이 당신의 전화에 설치됩니다'
    },
    installApp: '앱 설치',
    useWeb: '웹 버전 사용'
  },
  footer: {
    more: '메뉴'
  },
  menu: {
    installApp: '앱 설치',
    menu: '메뉴',
    close: '닫기'
  },
  relatedUsers: {
    seeall: '모두 보기'
  },
  networkingCurtain: {
    'newOneOnOne': '새로운 1:1',
    'details': '세부 사항',
    'coverMessage': '커버 메시지',
    'location': '위치',
    'duration': '기간',
    '15min': '15 분',
    '30min': '30 분',
    '45min': '45 분',
    '60min': '60 분',
    'timeSlot': '시간대',
    'sendInvitation': '초대 보내기',
    'success': '성공',
    'invitationSent':
      '1:1 미팅 초대가 성공적으로 전송되었습니다. 이 페이지에 머무르시겠습니까, 아니면 예정된 모든 1:1 미팅으로 이동하시겠습니까?',
    'seeAll': '모든 1:1 미팅 보기',
    'stayHere': '여기에 머무르기'
  },
  networking: {
    level: {
      1: '아직 네트워킹할 준비가 되지 않았습니다. 중요한 활동이나 참여가 없습니다.',
      2: '드물게 활동하거나 프로필 정보가 부족하여 다른 사람들이 연결하기 어렵습니다.',
      3: '사진이 포함된 프로필이 완료되고 온라인 상태로 네트워킹을 시작할 준비가 되었습니다.',
      4: '모멘텀 구축 중 - 지난 6시간 내에 최소한 하나의 연결을 시작했습니다.',
      5: '네트워킹의 대가 - 지난 6시간 동안 요청에 적극적으로 응답하고 다른 사람들과 소통했습니다.'
    }
  },
  time: {
    days: '일',
    hours: '시간',
    minutes: '분',
    seconds: '초',
    startsIn: '후',
    Today: '오늘',
    today: '오늘',
    Tomorrow: '내일',
    tomorrow: '내일',
    Yesterday: '어제',
    yesterday: '어제',
    startingNow: '지금 시작'
  },
  daysMonths: {
    months: "['1월','2월','3월','4월','5월','6월','7월','8월','9월','10월','11월','12월']",
    monthsShort: "['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월']",
    weekdays: "['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일']",
    weekdaysShort: "['일', '월', '화', '수', '목', '금', '토']",
    weekdaysMin: "['일', '월', '화', '수', '목', '금', '토']"
  },
  badges: {
    legend: 'Legendary Networker',
    push: 'Online and Trusted',
    leader: 'Leaderboard Champ',
    meetmaster: '1:1 Meeting Master',
    connector: '3-Time Connector',
    legend_description: '적극적으로 네트워킹하고 의미 있는 연결을 만들어서 전설 레벨을 한 번 이상 달성하세요.',
    push_description: '푸시 알림을 활성화하여 반응성을 유지하고 기회를 놓치지 마세요.',
    leader_description: '리더보드에서 최소한 한 번은 상위 10%에 들어가세요.',
    meetmaster_description: '앱 내에서 적어도 하나의 1:1 미팅 요청을 시작하거나 응답하세요.',
    connector_description: '앱을 통해 최소 세 개의 연결을 설정하세요.'
  }
}
